<script>
    import { drawFullImageOnCanvas, runPixelShuffleTransition } from "../../../helpers/onboardingImageTransition.js";
    import isMobile from "../../../helpers/mobile.js";
    export let image = null;

    let shouldPerformTransition = false;
    let canvas;

    async function startTransition() {
        const destinationImage = image;

        await runPixelShuffleTransition(canvas, image, function shouldAbort() {
            return destinationImage !== image;
        });
    }

    function drawImage() {
        drawFullImageOnCanvas(canvas, image).catch(function () {});
    }

    $: (() => {
        if (!image) {
            return;
        }

        if (!canvas) {
            return;
        }

        if (shouldPerformTransition) {
            startTransition().catch((error) => {
                console.warn("onboarding image transition failed", error);
            });
        } else {
            shouldPerformTransition = true;
            drawImage();
        }
    })();
</script>

{#if !isMobile}
    <canvas bind:this={canvas} />
{/if}

<style>
    canvas {
        display: block;
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        width: 100%;
        height: 100%;
    }
</style>
